import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Session } from '../services/session';
import isEmpty from 'lodash/isEmpty';

@Injectable()
export class GroupAccessGuard {
  constructor(private router: Router, @Inject(Session) private session) {}

  public canActivate(): boolean {
    const session = this.session;
    const visibility = session.getGroupVisibility();
    const allowedGroups = session.getAllowedGroups();

    if (session.isDispatcher() && visibility === 'limited' && isEmpty(allowedGroups)) {
      this.router.navigate(['/restricted']);
      return false;
    } else {
      return true;
    }
  }
}
